import Vue from 'vue'
// Lib imports
import axios from 'axios'
var production = true
Vue.prototype.$app_version = localStorage._kake_system_version
Vue.prototype.$app_mode = "Production"
var SERVER = "http://localhost:9181"
var TEST = "http://127.0.0.1:3000/" //"https://m5zupwjlhe.execute-api.ap-southeast-1.amazonaws.com/Stage/"
if(production) {
  if(Vue.prototype.$app_mode == "Production")
      SERVER = "https://server-dev.newtagum.com"
  else if(Vue.prototype.$app_mode == "Development")
        SERVER = "http://localhost:9181"
}
Vue.prototype.$http = axios.create({
  baseURL: SERVER + '/api/'
})
Vue.prototype.$httptest = axios.create({
  baseURL: TEST
})
Vue.prototype.$httplocal = axios.create({
  baseURL: '/'
})

Vue.prototype.$fileserver = SERVER + '/public/'